<script lang="ts" setup>
import type { MessageAttachmentDTO } from '@nora-monorepo/nora-api-client';
import {
  bgFillQuaternary,
  prettyPrintFileSize,
} from '@nora-monorepo/ui-shared';

import { getIcon } from '#nora-chat-ui/utils/get-extension';

interface VideoPreviewProps {
  attachment: MessageAttachmentDTO;
  isMyMessage: boolean;
  fillFrame?: boolean;
}

defineProps<VideoPreviewProps>();
</script>

<template>
  <div class="flex justify-center items-center h-full" :class="fillFrame ? bgFillQuaternary : ''">
    <div
      class="max-w-full max-h-full flex justify-center flex-col p-2"
      :class="[bgFillQuaternary, fillFrame ? 'w-full h-full' : 'w-32 h-28 rounded-xl']"
    >
      <span
        class="mi md-36 mx-auto"
        :class="[getIcon(attachment.mimeType)]"
      />
      <span class="text-xs line-clamp-3 text-center mb-1">{{
        attachment.fileName
      }}</span>
      <span class="text-xs text-center">{{
        prettyPrintFileSize(attachment.size)
      }}</span>
    </div>
  </div>
</template>
